export default __webpack_public_path__ + "b38e8a760762f7c2ca331a6bc796cd43.png";